
/**
 * 상세 에러 정보
 * @nullable
 */
export type PostApiV1RefundsRequest401ErrorDetails = { [key: string]: unknown } | null;
